var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrain(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.89591 22.9166H15.1042M8.33341 2.08331H16.6667M12.5001 5.20831V2.08331M4.16675 12.5H20.8334M17.7084 19.7916L19.2709 22.9166M7.29175 19.7916L5.72925 22.9166M8.85425 16.1458H8.86466M16.1459 16.1458H16.1563M9.16675 19.7916H15.8334C17.5836 19.7916 18.4587 19.7916 19.1271 19.451C19.7151 19.1514 20.1932 18.6734 20.4928 18.0854C20.8334 17.4169 20.8334 16.5418 20.8334 14.7916V10.2083C20.8334 8.45815 20.8334 7.58307 20.4928 6.91459C20.1932 6.32659 19.7151 5.84852 19.1271 5.54892C18.4587 5.20831 17.5836 5.20831 15.8334 5.20831H9.16675C7.41658 5.20831 6.5415 5.20831 5.87303 5.54892C5.28502 5.84852 4.80696 6.32659 4.50735 6.91459C4.16675 7.58307 4.16675 8.45815 4.16675 10.2083V14.7916C4.16675 16.5418 4.16675 17.4169 4.50735 18.0854C4.80696 18.6734 5.28502 19.1514 5.87303 19.451C6.5415 19.7916 7.41658 19.7916 9.16675 19.7916ZM9.37508 16.1458C9.37508 16.4335 9.1419 16.6666 8.85425 16.6666C8.5666 16.6666 8.33341 16.4335 8.33341 16.1458C8.33341 15.8582 8.5666 15.625 8.85425 15.625C9.1419 15.625 9.37508 15.8582 9.37508 16.1458ZM16.6667 16.1458C16.6667 16.4335 16.4336 16.6666 16.1459 16.6666C15.8583 16.6666 15.6251 16.4335 15.6251 16.1458C15.6251 15.8582 15.8583 15.625 16.1459 15.625C16.4336 15.625 16.6667 15.8582 16.6667 16.1458Z",
    stroke: "#E83E8C",
    strokeWidth: 2.08333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrain);
export default __webpack_public_path__ + "static/media/train.6835a37d3f88eb4091ca189fe59884d8.svg";
export { ForwardRef as ReactComponent };